// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'
import cl from 'classnames'
import { PopUp, PatientVisitTag } from 'ui_kit_qmd'
import { useNavigate } from 'react-router-dom'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import closeIcon from '../../../images/calendar/close.png'
import calendarIcon from '../../../images/common/calendar.png'
import trashIcon from '../../../images/calendar/trash.png'
import clockIcon from '../../../images/common/clock.png'
import editIcon from '../../../images/common/editIntake.png'
import trashBin from '../../../images/management/clinicMembers/trashBin.png'
import tabletImg from '../../../images/calendar/calendar-tablet-icon.png'
import {
  APPOINTMENT_ADDITIONAL_INFO_AMOUNT_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_BOOKING_STATE_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_EMAIL_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_PHONE_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_PROVIDER_NAME_OPTION,
  APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION,
  APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION,
  APPOINTMENT_INFO_PATIENT_NAME_ROW_ID,
  APPOINTMENT_VIEW_TYPE_LABEL,
  DETAILS_INFO_TYPE_AVAILABILITY,
  DETAILS_INFO_TYPE_PNB,
  IS_LAST_PAGE_WAS_CALENDAR_DETAILS_VIEW_LOCAL_STORAGE_KEY,
  PATIENTS_INFO_PREFFERED_NAME_ID,
  RESCHEDULE_VISIT_PAGE_PATH,
} from '../../../utils/constants'
import { getAgeByDate } from '../../../utils/commonCalendar'
import { isEllipsisActive } from '../../../utils/commonMembersPage'
import './DetailsView.scss'
import '../AvailabilityPopUp/AvailabilityPopUp.scss'
import { text } from './Constants'
import ScheduleDetailView from '../components/schedule-detail-view/ScheduleDetailView'
import {
  checkIsSameDay,
  convertMoneyToUSAFormat,
  FormatDate,
  getTimeZones,
  getVisitStatus,
  toTimeZone,
} from '../../../utils/common'
import AppointmentRibbonInfoBlock from '../components/AppointmentRibbonInfoBlock/AppointmentRibbonInfoBlock'
import { fullNameGenerator, phoneTextGenerator } from '../tools'
import { DATE_FORMAT_SLASH, DATE_TIME_ISO_FORMAT } from '../../../utils/dateUtils'
import { useRescheduleLocationState } from './hooks/useRescheduleLocationState'
import RescheduleVisit from '../../../components/reschedule-visit/RescheduleVisit'

const popUpContainerStyle = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 999999999,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
const popUpBoxStyle = {
  padding: '20px 24px',
  backgroundColor: '#ffffff',
  borderRadius: 4,
  position: 'relative',
  height: 'auto',
  flexDirection: 'column',
  display: 'flex',
  width: 877,
}

const DetailsView = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setShowDetails,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    detailsInfo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setShowEditAvailabilityView,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setClickedStartDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setClickedEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    ViewType,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    getScheduleInfoHandler,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    resetScheduleInfoRecurringHandler,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    customTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isAdminApp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSetDeleteEventConfirmationPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSetDeleteRecurringEventConfirmationPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onDelete,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypeGroups,
  }) => {
    const navigate = useNavigate()

    const { fromDateTime, toDateTime } = detailsInfo

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const loading = useSelector((state) => state.calendarPageReducer.loading)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const scheduleInfoRecurring = useSelector((state) => state.calendarPageReducer.scheduleInfoRecurring)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const AppointmentInfo = useSelector((state) => state.calendarPageReducer.AppointmentInfo)

    const [isNameWithTooltip, setIsNameWithTooltip] = useState(false)
    const [isNameTooltipVisible, setIsNameTooltipVisible] = useState(false)
    const [isPrefferedNameWithTooltip, setIsPrefferedNameWithTooltip] = useState(false)
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const [isPrefferedNameTooltipVisible, setIsPrefferedNameTooltipVisible] = useState(false)
    const [timeZoneAbbr, setTimeZoneAbbr] = useState('')

    const { getRescheduleLocationState } = useRescheduleLocationState()

    const isAllowEditing = moment().isBefore(moment(toDateTime).parseZone().tz(customTimeZone, true))
    const isVisitWithTag = detailsInfo?.IsNewForServiceType || detailsInfo?.IsNewForPatient
    const isPriceChanged = detailsInfo?.IsPriceChanged && !detailsInfo?.Coverage
    const IsVisitTypeAvailable = detailsInfo?.IsVisitTypeAvailable

    const showNameTooltip = () => {
      setIsNameTooltipVisible(true)
    }
    const hideNameTooltip = () => {
      setIsNameTooltipVisible(false)
    }
    const timezones = getTimeZones(allTimezones)
    const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })

    const appointmentVisitInfoOptions = useMemo(
      () => [
        {
          name: APPOINTMENT_ADDITIONAL_INFO_PROVIDER_NAME_OPTION,
          value: fullNameGenerator(detailsInfo?.Provider || {}),
        },
        {
          name: APPOINTMENT_ADDITIONAL_INFO_AMOUNT_OPTION,
          value: convertMoneyToUSAFormat.format(detailsInfo?.Price),
        },
        {
          name: APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION,
          value: `${detailsInfo?.ServiceTypeName} (${detailsInfo?.VisitTypeName})`,
        },
        {
          name: APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION,
          value: detailsInfo.Method,
        },
        {
          name: APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION,
          value: getVisitStatus(detailsInfo?.Status),
        },
      ],
      [
        detailsInfo.Method,
        detailsInfo?.Price,
        detailsInfo?.Provider?.FirstName,
        detailsInfo?.Provider?.LastName,
        detailsInfo?.Provider?.Prefix,
        detailsInfo?.Provider?.Suffix,
        detailsInfo?.ServiceTypeName,
        detailsInfo?.VisitTypeName,
        detailsInfo?.Status,
      ],
    )

    const appointmentPatientInfoOptions = useMemo(
      () => [
        {
          name: APPOINTMENT_ADDITIONAL_INFO_PHONE_OPTION,
          value: phoneTextGenerator(detailsInfo?.Patient?.PhoneNumber),
        },
        {
          name: APPOINTMENT_ADDITIONAL_INFO_EMAIL_OPTION,
          value: detailsInfo?.Patient?.Email,
        },
        {
          name: APPOINTMENT_ADDITIONAL_INFO_BOOKING_STATE_OPTION,
          value: detailsInfo?.StateCode || '--',
        },
      ],
      [detailsInfo?.Patient?.Email, detailsInfo?.Patient?.PhoneNumber, detailsInfo?.StateCode],
    )

    const onOpenDeletePopUp = useCallback(() => {
      if (scheduleInfoRecurring) {
        onSetDeleteRecurringEventConfirmationPopUp({
          detailsInfo,
          customTimeZone,
          scheduleInfoRecurring,
        })
      } else {
        onSetDeleteEventConfirmationPopUp({ itemId: detailsInfo.id, toDateTime })
      }
    }, [
      customTimeZone,
      detailsInfo,
      onSetDeleteEventConfirmationPopUp,
      onSetDeleteRecurringEventConfirmationPopUp,
      scheduleInfoRecurring,
      toDateTime,
    ])
    const onOpenEditPopUp = useCallback(() => {
      const fromDateTimeAccordinglyTZ = moment(fromDateTime).parseZone().tz(customTimeZone, true)
      const toDateTimeAccordinglyTZ = moment(toDateTime).parseZone().tz(customTimeZone, true)

      const startTime = {
        displayDate: fromDateTimeAccordinglyTZ.format('dddd MMM D YYYY'),
        displayTime: fromDateTimeAccordinglyTZ.format('hh:mma'),
        dateTime: fromDateTimeAccordinglyTZ.format(DATE_TIME_ISO_FORMAT),
      }
      const endTime = {
        displayDate: toDateTimeAccordinglyTZ.format('dddd MMM D YYYY'),
        displayTime: toDateTimeAccordinglyTZ.format('hh:mma'),
        dateTime: toDateTimeAccordinglyTZ.format(DATE_TIME_ISO_FORMAT),
      }
      setClickedStartDateTime(startTime)
      setClickedEndDateTime(endTime)
      setShowDetails(false)
      if (detailsInfo.type === DETAILS_INFO_TYPE_PNB || detailsInfo.type.includes(DETAILS_INFO_TYPE_AVAILABILITY)) {
        setShowEditAvailabilityView({
          itemId: detailsInfo.id,
          scheduleId: detailsInfo.scheduleId,
          scheduleOrder: detailsInfo.scheduleOrder,
          visitTypeGroupId: detailsInfo.visitTypeGroupId,
          type: detailsInfo.type,
          isRecursive: !!scheduleInfoRecurring,
          EndDateTime: {
            dateTime: scheduleInfoRecurring?.EndDateTime ?? {},
            displayDate: moment(scheduleInfoRecurring?.EndDateTime).format('dddd MMM D YYYY') ?? {},
          },
          RecurringType: scheduleInfoRecurring?.RecurringType ?? {},
          RepeatDays: scheduleInfoRecurring?.WeekDays ?? [],
          OccurrenceStartTime: startTime,
          OccurrenceEndTime: endTime,
        })
      } else {
        setShowEditAvailabilityView({
          itemId: detailsInfo.id,
          type: detailsInfo.type,
          visitTypeGroupId: detailsInfo.visitTypeGroupId,
          isRecursive: !!scheduleInfoRecurring,
          EndDateTime: {
            dateTime: scheduleInfoRecurring?.EndDateTime ?? {},
            displayDate: moment(scheduleInfoRecurring?.EndDateTime).format('dddd MMM D YYYY') ?? {},
          },
          RecurringType: scheduleInfoRecurring?.RecurringType ?? {},
          RepeatDays: scheduleInfoRecurring?.WeekDays ?? [],
        })
      }
    }, [
      customTimeZone,
      detailsInfo.id,
      detailsInfo.scheduleId,
      detailsInfo.scheduleOrder,
      detailsInfo.type,
      detailsInfo.visitTypeGroupId,
      fromDateTime,
      scheduleInfoRecurring,
      setClickedEndDateTime,
      setClickedStartDateTime,
      setShowDetails,
      setShowEditAvailabilityView,
      toDateTime,
    ])
    useEffect(() => {
      if (ViewType === APPOINTMENT_VIEW_TYPE_LABEL) {
        if (isEllipsisActive(document.getElementById(APPOINTMENT_INFO_PATIENT_NAME_ROW_ID))) {
          setIsNameWithTooltip(true)
        }
        if (isEllipsisActive(document.getElementById(PATIENTS_INFO_PREFFERED_NAME_ID))) {
          setIsPrefferedNameWithTooltip(true)
        }
      }
    }, [detailsInfo])

    useLayoutEffect(() => {
      if (ViewType === APPOINTMENT_VIEW_TYPE_LABEL) {
        /* empty */
      } else if (detailsInfo.scheduleId) {
        getScheduleInfoHandler(detailsInfo.scheduleId)
      }
      return () => resetScheduleInfoRecurringHandler()
    }, [])

    const patientNameToolTipBox = useMemo(
      () => ({
        visibility: isNameTooltipVisible ? 'visible' : 'hidden',
      }),
      [isNameTooltipVisible],
    )

    const onClosePopUp = () => {
      setShowDetails(false)
    }

    const onClickPatientName = () => {
      localStorage.setItem(IS_LAST_PAGE_WAS_CALENDAR_DETAILS_VIEW_LOCAL_STORAGE_KEY, JSON.stringify(true))
      navigate(`/patientcharts/patient?id=${AppointmentInfo?.Patient?.PatientId}`)
      onClosePopUp()
    }

    const checkIsSameDayCondition = checkIsSameDay(
      toTimeZone(detailsInfo.timeInUTC?.start, customTimeZone),
      toTimeZone(detailsInfo.timeInUTC?.end, customTimeZone),
    )

    useEffect(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setTimeZoneAbbr(parseTimezone(customTimeZone).label)
    }, [customTimeZone])

    const redirectToRescheduleVisitPage = () => {
      navigate(RESCHEDULE_VISIT_PAGE_PATH, {
        state: getRescheduleLocationState(detailsInfo, customTimeZone),
      })
    }

    if (loading && !detailsInfo) {
      return <div />
    }
    return (
      <PopUp
        popUpContainerStyle={popUpContainerStyle}
        popUpBoxStyle={popUpBoxStyle}
        content={
          ViewType === APPOINTMENT_VIEW_TYPE_LABEL ?
            <>
              <div className='appointment-details-header-container'>
                <div className='availability-details-title'>
                  <div className='patients-main-info-container'>
                    <div
                      role='presentation'
                      className={isAdminApp ? 'patient-name-container-admin-view' : 'patient-name-container'}
                      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                      onClick={isAdminApp ? null : onClickPatientName}>
                      <img className='tabletImg' src={tabletImg} alt='tabletImg' />
                      {isNameWithTooltip ?
                        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                        <div style={patientNameToolTipBox} className='patientName-tooltip-box'>
                          {detailsInfo?.FirstName} {detailsInfo?.Patient?.LastName}
                        </div>
                      : null}
                      <div
                        onMouseOver={showNameTooltip}
                        onFocus={showNameTooltip}
                        onMouseLeave={hideNameTooltip}
                        onBlur={hideNameTooltip}
                        id={APPOINTMENT_INFO_PATIENT_NAME_ROW_ID}
                        className={cl('patient-name-row-text', {
                          'patient-name-row-text--with-tag': isVisitWithTag,
                        })}>
                        <div />
                        {detailsInfo?.Patient?.FirstName} {detailsInfo?.Patient?.LastName}
                      </div>
                      ({getAgeByDate(detailsInfo?.Patient?.BirthDate)}/
                      {detailsInfo?.Patient?.Gender === 'female' ? 'F' : 'M'})
                      <PatientVisitTag
                        className='details-view-patient-tag'
                        isNewForServiceType={detailsInfo?.IsNewForServiceType}
                        isNewForPatient={detailsInfo?.IsNewForPatient}
                      />
                    </div>
                    <div className='patients-info-subtexts-wrapper'>
                      <div className='patients-info-preffered-name-main-wrapper'>
                        {isPrefferedNameWithTooltip && isPrefferedNameTooltipVisible ?
                          <div className='patients-info-preffered-name-tooltip-box'>
                            {detailsInfo?.Patient?.PreferredName}
                          </div>
                        : null}
                        <div className='patients-info-subText patients-info-preffered-name-wrapper'>
                          DOB: {moment(detailsInfo?.Patient?.BirthDate).format(DATE_FORMAT_SLASH)}
                        </div>
                        <div className='patients-info-subtexts-separator' />
                      </div>
                      <div className='patients-info-subText'>MRN: {detailsInfo?.Patient?.MedicalRecordNumber}</div>
                    </div>
                  </div>
                </div>
                <div className='availability-header-right-container'>
                  <RescheduleVisit
                    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                    status={detailsInfo?.Status}
                    isPriceChanged={isPriceChanged}
                    IsVisitTypeAvailable={IsVisitTypeAvailable}
                    redirectToRescheduleVisitPage={redirectToRescheduleVisitPage}
                  />
                  {detailsInfo.IsCancellationAllowed ?
                    <img
                      role='presentation'
                      alt={text.DELETE}
                      src={trashIcon}
                      className='availability-trash-details-img'
                      onClick={onDelete}
                    />
                  : null}
                  <img
                    role='presentation'
                    alt={text.CLOSE}
                    src={closeIcon}
                    className='availability-close-details-img'
                    onClick={onClosePopUp}
                  />
                </div>
              </div>
              <div className='availability-details-container-appointment'>
                <div
                  className={
                    checkIsSameDayCondition ? 'availability-details-row' : 'availability-details-row-overlap-version'
                  }>
                  <div className='appointment-details-inner-row'>
                    <img className='availability-detils-img' src={calendarIcon} alt='Date' />
                    {checkIsSameDayCondition ?
                      <span className='availability-details-text'>
                        {FormatDate(detailsInfo?.FromDateTime, 'Date', customTimeZone)}
                      </span>
                    : null}
                  </div>
                  {checkIsSameDayCondition ?
                    <div className='appointment-details-inner-row'>
                      <img className='availability-detils-img' src={clockIcon} alt='Time' />
                      <span className='availability-details-text'>
                        {FormatDate(detailsInfo.FromDateTime, 'Time', customTimeZone)} -{' '}
                        {FormatDate(detailsInfo.ToDateTime, 'Time', customTimeZone)}
                      </span>
                      ({timeZoneAbbr})
                    </div>
                  : <div className='appointment-details-inner-row-overlap-version'>
                      <span
                        className={
                          checkIsSameDayCondition ? 'availability-details-text' : (
                            'appointment-details-text-overlap-version'
                          )
                        }>
                        {moment(detailsInfo.FromDateTime).format('dddd MMM DD YYYY, h:mma')} -{' '}
                        {moment(detailsInfo.ToDateTime).format('dddd MMM DD YYYY, h:mma')}
                      </span>
                    </div>
                  }
                </div>
              </div>
              {/*
               // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
              <AppointmentRibbonInfoBlock title='Patient information' dataList={appointmentPatientInfoOptions} />
              {/*
               // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
              <AppointmentRibbonInfoBlock title='Visit information' dataList={appointmentVisitInfoOptions} />
            </>
          : <>
              <div className='availability-details-header-container'>
                <span className='availability-details-title'>
                  {detailsInfo.type === 'PNB' ? 'Prevent new bookings' : 'Available'}
                </span>
                <div className='availability-header-right-container'>
                  {isAllowEditing ?
                    <img
                      role='presentation'
                      alt='editIcon'
                      src={editIcon}
                      className='edit-img'
                      onClick={onOpenEditPopUp}
                    />
                  : null}

                  {isAllowEditing ?
                    <img
                      role='presentation'
                      alt='deleteIcon'
                      src={trashBin}
                      className='delete-event-img'
                      onClick={onOpenDeletePopUp}
                    />
                  : null}

                  <img
                    role='presentation'
                    alt='Close'
                    src={closeIcon}
                    className='availability-close-details-img'
                    onClick={onClosePopUp}
                  />
                </div>
              </div>
              <ScheduleDetailView
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                detailsInfo={detailsInfo}
                customTimeZone={customTimeZone}
                scheduleInfoRecurring={scheduleInfoRecurring}
                visitTypeGroups={visitTypeGroups}
              />
            </>
        }
      />
    )
  },
)

export default DetailsView
